export var COLLAPSE_PERMISSIONS_ROLE = 'collapse_permissions_role';